// Auto-executing code setting up the user context for Sentry
// This actually goes to js/lib/sentry
import '@sentry/react';
import Q from 'q';

import config from 'js/app/config';
import logger from 'js/app/loggerSingleton';
import { isLocalStorageEnabled } from 'js/lib/envHelper';
import persistQueryParams from 'js/lib/persistQueryParams';

// Not supported in SSR
if (typeof window !== 'undefined') {
  if (
    isLocalStorageEnabled() &&
    (localStorage.getItem('debug:longStackSupport') || config.environment !== 'production')
  ) {
    // do not swallow require.js thrown errors in dev mode!
    Q.longStackSupport = true;

    // Work around for chrome not printing correct stack trace
    // See https://code.google.com/p/chromium/issues/detail?id=249575 and
    // https://github.com/kriskowal/q/issues/424
    Q.onerror = function (err) {
      logger.error(err.stack);
    };
  }

  // persist these trackers across page views for tracking purposes
  persistQueryParams(window.location.href, [
    'locale',
    // Used to generate tracking calls to nanigans (paid ads service)
    'nan_pid',
  ]);
}
